import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './locked-div.scss';
import { isNotLogin, isNotLoginOrExpired } from '../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../helpers/EventEmitter';

class LockedDiv extends PureComponent {
  onClick = () => {
    const { user, allowExpired, onShowPopup } = this.props;
    if (allowExpired) {
      if (isNotLogin(user)) {
        onShowPopup();
        EventEmitter.dispatch(SHOW_GUEST_POPUP);
      }
      return;
    }
    if (isNotLoginOrExpired(user)) {
      onShowPopup();
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
    }
  };

  isLocked = () => {
    const { allowExpired, user } = this.props;
    if (allowExpired) {
      return isNotLogin(user);
    }

    return isNotLoginOrExpired(user);
  };

  render() {
    const { children } = this.props;
    return (
      <div
        onClick={this.onClick}
        className={this.isLocked() ? 'locked-div' : ''}
      >
        {children}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userInfo,
});

LockedDiv.propTypes = {
  allowExpired: PropTypes.bool,
  onShowPopup: PropTypes.func,
};

LockedDiv.defaultProps = {
  allowExpired: false,
  onShowPopup: () => {},
};

export default connect(mapStateToProps)(LockedDiv);
